<form [formGroup]="formGroup!">
    <div class="sera-inputs-and-slider-wrapper">
        <div class="sera-inputs-and-slider-wrapper__input-number-container">
            <density-input-number
                [min]="leftInputMin"
                [max]="leftInputMax"
                [isDisabled]="isLeftInputDisabled"
                [isReadOnly]="isLeftInputReadOnly"
                [label]="leftInputLabel"
                [color]="color"
                [formControlName]="leftInputFormControl"
                (valueChanged)="onLeftNumberChanged($event)"></density-input-number>
            <density-input-number
                [min]="rightInputMin"
                [max]="rightInputMax"
                [isDisabled]="isRightInputDisabled"
                [isReadOnly]="isRightInputReadOnly"
                [label]="rightInputLabel"
                [color]="color"
                [formControlName]="rightInputFormControl"
                [decimals]="decimalsRightInput"
                (valueChanged)="onRightNumberChanged($event)"></density-input-number>
        </div>
        <sera-range-slider
            [min]="rangeSliderMin"
            [max]="rangeSliderMax"
            [isDisabled]="isRangeSliderDisabled"
            [isReadOnly]="isRangeSliderReadOnly"
            [color]="color"
            [formControlName]="rangeSliderFormControl"
            (slideChange)="onRangeSliderChanged($event)"
            (slideEnd)="onRangeSliderEnd($event)"></sera-range-slider>
    </div>
</form>
